import React from "react";
import { observer } from "mobx-react";
import UiMeet3dEventIndexPage from "~/modules/UiMeet3d/app/UiMeet3dEventIndexPage";
import "../styles/TourIndexHeader.less";
import "../styles/SidePage.less";
// Moving the styles of the LayoutWrapper here to avoid getting the wrong variables
import "../styles/TourLayout.less";

const PanelUiMeet3dEventIndexPage = observer(props => <UiMeet3dEventIndexPage {...props} />);

export default PanelUiMeet3dEventIndexPage;
